import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AlertModule } from '../alert/alert.module';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';

import { MiniMapComponent } from './components/mini-map.component';
import { WebMapComponent } from './components/web-map.component';
import { WebMapPageComponent } from './components/web-map-page.component';

@NgModule({
  imports: [
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    NgScrollbarModule,
    NgxMatSelectSearchModule,
    AlertModule,
    DragDropModule,
    SharedModule,
    MatProgressSpinnerModule,
    WebMapComponent,
    MiniMapComponent,
    WebMapPageComponent,
  ],
  exports: [WebMapComponent, MiniMapComponent, WebMapPageComponent],
  providers: [],
})
export class MapModule {}
